import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import client from "../../api/client";

export default function AdminCohortsPage() {
  const navigate = useNavigate();
  const [cohorts, setCohorts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("nd-rest-tkn");
    if (token) client.defaults.headers.Authorization = `Bearer ${token}`;
    client.get("/admin/cohorts")
      .then(res => setCohorts(res.data))
      .catch(() => toast.error("Failed to load cohorts."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 md:p-8 max-w-5xl mx-auto">
      <div className="mb-6">
        <h1 className="text-xl font-bold text-gray-900">Cohorts</h1>
        <p className="text-sm text-gray-500 mt-0.5">
          {cohorts.length} open cohort{cohorts.length !== 1 ? "s" : ""} — click a cohort to see its courses and classes
        </p>
      </div>

      {loading ? (
        <div className="space-y-3">{[1, 2, 3, 4].map(i => <div key={i} className="h-20 bg-white rounded-2xl border border-gray-100 animate-pulse" />)}</div>
      ) : cohorts.length === 0 ? (
        <div className="p-16 text-center bg-white rounded-2xl border border-gray-100">
          <p className="text-4xl mb-3">🗓️</p>
          <p className="text-sm font-medium text-gray-600">No open cohorts</p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden divide-y divide-gray-100">
          {cohorts.map(cohort => (
            <button
              key={cohort.id}
              onClick={() => navigate(`/dashboard/admin/cohorts/${cohort.id}`)}
              className="w-full flex items-center justify-between gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left"
            >
              <div className="min-w-0">
                <p className="font-semibold text-gray-800 text-sm truncate">{cohort.name}</p>
                <div className="flex items-center gap-3 mt-1">
                  <span className="text-xs text-gray-400">
                    {cohort.start_date ? new Date(cohort.start_date).toLocaleDateString() : "—"}
                    {cohort.end_date ? ` → ${new Date(cohort.end_date).toLocaleDateString()}` : ""}
                  </span>
                  <span className="text-xs text-gray-400">{cohort.courses_count ?? 0} course{(cohort.courses_count ?? 0) !== 1 ? "s" : ""}</span>
                  <span className="text-xs text-gray-400">{cohort.subscribers_count ?? 0} enrolled</span>
                </div>
              </div>
              <span className="flex-shrink-0 text-xs px-2 py-0.5 rounded-full font-semibold bg-green-100 text-green-700">
                Open
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
